import { useEffect } from "react";
import { useWishlistSync } from "@/hooks/useWishlistSync";
import { useCartSync } from "@/hooks/useCartSync";

/**
 * Component that initializes sync hooks for wishlist and cart
 * Should be rendered once at the app root level
 */
const SyncProvider = ({ children }: { children: React.ReactNode }) => {
  // Initialize wishlist sync with database
  useWishlistSync();
  
  // Initialize cart sync for abandoned cart tracking
  useCartSync();

  return <>{children}</>;
};

export default SyncProvider;
